import React, { useEffect, useReducer, useState, useRef } from "react";
import PersonIcon from '@mui/icons-material/Person';
import { TableRow, TableCell } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ReorderIcon from '@mui/icons-material/Reorder';
function PendingChatThread({ key, thread, fetchTextMessageThread, pendingTextMessageThreads, setPendingTextMessageThreads }) {
  return(
    <TableRow
      className={'pending-chat-thread-container'}
      onClick={(el) => {
        if (setPendingTextMessageThreads && pendingTextMessageThreads) {
          pendingTextMessageThreads.pop((el) => {
            return el.id == thread.id;
          });
          setPendingTextMessageThreads(pendingTextMessageThreads);
        }
        fetchTextMessageThread(thread.id)
      }}
      key={key}>
      <TableCell> <PhoneIcon sx={{ color: '#2cb5fa', verticalAlign: 'bottom' }}/> {thread['phone_number']}</TableCell>
      <TableCell> <PersonIcon sx={{  color: '#2cb5fa', verticalAlign: 'bottom' }} /> {thread['patient_name'] || 'Unknown'}</TableCell>
      <TableCell> <AccessTimeIcon sx={{  color: '#2cb5fa', verticalAlign: 'bottom' }} /> {thread['last_sent_at']}</TableCell>
      <TableCell> <ReorderIcon sx={{  color: '#2cb5fa', verticalAlign: 'bottom' }} /> {thread['text_messages_count']}</TableCell>
    </TableRow>
  );
}

export default PendingChatThread;
